import { MetricCard } from '@/components/molecules/MetricCard';
import type { ChartProps } from '@/pages/Workflows/components/molecules/common/types';
import type { WorkflowChartData } from '@/pages/Workflows/components/organisms/WorkflowStatusChart';
import { WorkflowChart } from '@/pages/Workflows/components/organisms/WorkflowStatusChart';
import { useMemo } from 'react';

export type ActivePerWorkflowChartData = {
  workflowName: string;
  count: number;
  fillColor: string;
};

type Props = {
  data: ActivePerWorkflowChartData[];
} & ChartProps;

export const ActivePerWorkflowChart = ({ isLoading, data }: Props) => {
  const chartData: WorkflowChartData[] = useMemo(
    () =>
      data.map(item => ({
        label: item.workflowName,
        value: item.count,
        fill: item.fillColor,
      })),
    [data],
  );

  return (
    <MetricCard
      isLoading={isLoading}
      title={<MetricCard.Title title="Active per workflow" />}
      content={
        <MetricCard.Content>
          <WorkflowChart size={90} innerRadius={26} outerRadius={40} data={chartData} />
        </MetricCard.Content>
      }
    />
  );
};
